String.prototype.replaceAll = function(search, replacement) {
  var target = this;
  return target.split(search).join(replacement);
};
export const convertLineBreaks = text => {
  let t = text.replaceAll("<p>", "");
  t = t.replaceAll("</p>", "\n");
  t = t.replaceAll("<br>", "\n");
  t = t.replaceAll("<br/>", "\n");
  t = t.replaceAll("<br />", "\n");
  return t;
};



// WEBPACK FOOTER //
// ./src/utils.js